import DOMPurify from 'dompurify';

// Central sanitizer for the few places that must render HTML through
// `dangerouslySetInnerHTML` (i18n strings carrying markup, CMS-authored news
// titles). Routing every such value through DOMPurify strips any injected
// script/handler while keeping the intended formatting tags, so a callsite
// can't become an XSS vector even if its source (backend/CMS content, or an
// i18n string interpolating user input with `escapeValue: false`) holds markup.
export const sanitizeHtml = (dirty: string): string => DOMPurify.sanitize(dirty);
